import { lazy } from "react";

// const PaymentDue = lazy(() => import("@views/PaymentDue"))
const PaymentDue = lazy(() => import("@views/PaymentDue"))

const PaymentDueRoute = [
    {
        path: '/paymentdue',
        element: <PaymentDue />,
        meta: {
            layout: "blank"
        }
    },
]

export default PaymentDueRoute
